module.exports = __webpack_public_path__ + "static/example-e127364850acd75ea55335b57f14ca18.png";